import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { Button } from '../../components/ui/button';
import { CheckCircle2, Loader2, AlertTriangle } from 'lucide-react';
import api from '../../lib/api';

export default function DocuSignOAuthSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  
  useEffect(() => {
    checkOAuthStatus();
  }, []);
  
  const checkOAuthStatus = async () => {
    try {
      const res = await api.get('/docusign/oauth/status');
      if (res.data.authenticated) {
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Failed to check OAuth status:', error);
      setStatus('error');
    }
  };
  
  if (status === 'loading') {
    return (
      <DashboardLayout>
        <div className="max-w-2xl mx-auto">
          <div className="stat-card text-center py-12">
            <Loader2 className="w-16 h-16 animate-spin text-blue-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold mb-2">Connecting to DocuSign...</h2>
            <p className="text-slate-400">Please wait while we complete the authentication</p>
          </div>
        </div>
      </DashboardLayout>
    );
  }
  
  if (status === 'error') {
    return (
      <DashboardLayout>
        <div className="max-w-2xl mx-auto">
          <div className="stat-card text-center py-12">
            <AlertTriangle className="w-16 h-16 text-red-400 mx-auto mb-4" />
            <h2 className="text-2xl font-bold mb-2">Authentication Failed</h2>
            <p className="text-slate-400 mb-6">
              There was an error connecting to DocuSign
            </p>
            <Button onClick={() => navigate('/dashboard')} className="gradient-accent">
              Return to Dashboard
            </Button>
          </div>
        </div>
      </DashboardLayout>
    );
  }
  
  return (
    <DashboardLayout>
      <div className="max-w-2xl mx-auto">
        <div className="stat-card text-center py-12">
          <CheckCircle2 className="w-16 h-16 text-emerald-400 mx-auto mb-4" />
          <h2 className="text-2xl font-bold mb-2">DocuSign Connected!</h2>
          <p className="text-slate-400 mb-6">
            Your DocuSign account has been successfully connected. You can now send documents for signature.
          </p>
          <Button onClick={() => navigate('/dashboard')} className="gradient-accent">
            Continue to Dashboard
          </Button>
        </div>
      </div>
    </DashboardLayout>
  );
}
